import Grid from "@mui/material/Grid";
import ModelAutoComplete from "../../actprep-ui/components/ModelAutoComplete";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { actSubjects } from "../../actprep-ui/constants/program";
import { capitalize } from "../../actprep-ui/utils/formatting";

export default function ChallengeItemExtraFields({ formData, setFormData }) {
  return (
    <>
      <Grid
        size={{
          sm: 6,
          xs: 12,
        }}
      >
        <FormControl fullWidth variant="standard">
          <InputLabel>Subject</InputLabel>
          <Select
            value={formData.item_metadata?.subject || ""}
            label="Subject"
            required
            onChange={(event) =>
              setFormData((formData) => {
                formData.item_metadata.subject = event.target.value;
                return { ...formData };
              })
            }
          >
            {actSubjects.map((subject) => (
              <MenuItem key={subject} value={subject}>
                {capitalize(subject)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid size={6}>
        <FormControl fullWidth variant="standard">
          <InputLabel>Challenge Option</InputLabel>
          <Select
            value={
              formData.item_metadata?.automatically_select_challenge !==
              undefined
                ? formData.item_metadata?.automatically_select_challenge
                : ""
            }
            label="Challenge Option"
            required
            onChange={(event) => {
              setFormData({
                ...formData,
                item_metadata: {
                  ...formData.item_metadata,
                  automatically_select_challenge: event.target.value,
                },
              });
            }}
          >
            <MenuItem value={true}>Automatically Select Challenge</MenuItem>
            <MenuItem value={false}>Choose Challenge</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      {formData.item_metadata.automatically_select_challenge === false && (
        <Grid size={12}>
          <ModelAutoComplete
            required
            modelName={"Challenge"}
            label={"Challenge"}
            variant="standard"
            value={formData.item_metadata?.challenge || null}
            setValue={(newChallenge) =>
              setFormData((formData) => {
                formData.item_metadata.challenge = newChallenge;
                return { ...formData };
              })
            }
          />
        </Grid>
      )}
    </>
  );
}
